import smallBanner1x from "../../../../public/images/shelter_materials/shelter_banner_small_1x.png"
import smallBanner2x from "../../../../public/images/shelter_materials/shelter_banner_small_2x.png"
import largeBanner1x from "../../../../public/images/shelter_materials/shelter_banner_large_1x.png"
import largeBanner2x from "../../../../public/images/shelter_materials/shelter_banner_large_2x.png"

export const SHELTER_BANNERS = [
  {
    title: "バナー小",
    size: "W320xH100px",
    width: 320,
    src: smallBanner1x,
    path: "/shelter_materials/banner_small_1x",
  },
  {
    title: "バナー小 2xサイズ",
    size: "W640xH200px",
    width: 320,
    src: smallBanner2x,
    path: "/shelter_materials/banner_small_2x",
  },
  {
    title: "バナー大",
    size: "W728xH90px",
    width: 728,
    src: largeBanner1x,
    path: "/shelter_materials/banner_large_1x",
  },
  {
    title: "バナー大 2xサイズ",
    size: "W1456xH180px",
    width: 728,
    src: largeBanner2x,
    path: "/shelter_materials/banner_large_2x",
  },
]
